import { useEffect } from "react";

const IntercomChatPage = () => {
  useEffect(() => {
    // Configuration Intercom
    window.intercomSettings = {
      app_id: "w51btoii",
    };

    // Fonction d'ouverture forcée
    const loadIntercom = () => {
      if (typeof window.Intercom === "function") {
        window.Intercom("boot", window.intercomSettings);
        window.Intercom("show"); // Ouvre directement le chat
      } else {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/w51btoii";
        s.onload = () => {
          window.Intercom("boot", window.intercomSettings);
          window.Intercom("show");
        };
        document.head.appendChild(s);
      }
    };

    loadIntercom();

    // Cleanup (important pour SPA / React)
    return () => {
      if (typeof window.Intercom === "function") {
        window.Intercom("shutdown");
      }
    };
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Parle-nous !</h1>
      <p className="text-lg">Le chat est déjà ouvert, tu peux poser ta question juste en bas 👇</p>
    </div>
  );
};

export default IntercomChatPage;